import React from "react";
import "./Signup.css";
import FadeIn from "react-fade-in";

//Class to display "Hjelp" button on the seat reservation menu
//Shows modal of legend

export class CheckSignupModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inputData: "",
      error: false,
      data: []
    };

    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.getData = this.getData.bind(this);
  }

  onChange(e) {
    let value = e.target.value.replace(" ", "");
    this.setState({ inputData: value });
  }

  async onClick(e) {
    let data = await this.getData();
    console.log(data);
    if (data === 403 || data === 404 || data === undefined) {
      let dataholder = [];
      dataholder.push("Kunne ikke finne påmeldingsdata");
      await this.setState({ data: dataholder });
    } else {
      await this.setState({ data: data });
    }
    return;
  }

  async getData() {
    await this.setState({ error: false });
    let data = await fetch(
      "api/seating/getRegistered/" + this.state.inputData,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          pragma: "no-cache",
          "cache-control": "no-cache"
        }
      }
    )
      .then(function(response) {
        return response.json();
      })
      .catch(() => {
        this.setState({ error: true });
        return 404;
      });
    return data;
  }

  render() {
    const info = (
      <div className="infoModal">
        <h3> Sjekk din påmeldingsstatus </h3>
        <br />
        <h6>Tast inn din Vippskode som du fikk på mail når du meldte deg på</h6>
        <p>(Du finner den på ordrebekreftelsen - 6 tegn)</p>
        <input
          className="inputCode"
          placeholder="Vippskode"
          onChange={this.onChange}
          type="text"
        ></input>
        <button onClick={this.onClick} className="btn btno btn-info">
          Sjekk status
        </button>
      </div>
    );

    let userData = [];
    let betalt = "";
    let matbillett = "";
    if (this.state.error === false) {
      for (let i = 0; i < this.state.data.length; i++) {
        if (this.state.data[i].paid === true) {
          betalt = "Ja";
        } else {
          betalt = "Nei";
        }

        if (this.state.data[i].foodTicket === true) {
          matbillett = "Ja";
        } else {
          matbillett = "Nei";
        }

        userData.push(
          <div className="card" key={userData.length}>
            <h5>
              Rad: {this.state.data[i].rowNum} Plass:{" "}
              {this.state.data[i].seatNum}
            </h5>{" "}
            {this.props.foodTicketEnabled && <h6>Matbillett: {matbillett}</h6>}{" "}
            <h6>Betalt: {betalt}</h6>
          </div>
        );
      }
      userData.push(
        <p key="notice">
          Merk at det kan ta inntil 3 dager fra innbetaling før betalingsstatus
          oppdateres
        </p>
      );
    } else if (this.state.error === true) {
      userData.push(<p key="feil">Kunne ikke finne din påmelding</p>);
    }

    return (
      <div className="seatModal">
        <FadeIn>
          {info}
          <div>{userData}</div>
          <div className="btnSpace">
            <button
              className="btn btno btn-danger help"
              onClick={this.props.closeCheckSignupModal}
            >
              {" "}
              Lukk{" "}
            </button>
          </div>
        </FadeIn>
      </div>
    );
  }
}

export default CheckSignupModal;



// WEBPACK FOOTER //
// ./src/Components/Signup/CheckSignupModal.js